import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  from,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import env from 'env';
import { getRecaptchaToken } from 'lib/recaptcha/recaptcha';

const httpLink = createHttpLink({
  uri: `${env.SUBSCRIPTIONS_URI}/graphql-public`,
});

const isProd = process.env.NODE_ENV === 'production';

const recaptchaToken = async () => {
  if (isProd) return await getRecaptchaToken();
  return null;
};

const recaptchaLink = setContext(async (_, { headers }) => {
  try {
    const token = await recaptchaToken();

    return {
      headers: {
        ...headers,
        ...(token && { 'x-recaptcha-token': token }),
      },
    };
  } catch (e) {
    return {
      headers,
    };
  }
});

const linkArray = [recaptchaLink, httpLink];

const client = new ApolloClient({
  link: from(linkArray),
  cache: new InMemoryCache(),
});

export default client;
